import React from "react";
import { ArrowDown, Phone, FileText } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AboutNordputzHero() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll();
  const {
    ref: buttonsRef,
    isVisible: buttonsVisible
  } = useRevealOnScroll({
    threshold: 0.5
  });
  return <section data-section-id="34190" id="hero-banner" className="relative flex min-h-[90vh] w-full items-center justify-center overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 z-0">
        <div className="h-full w-full bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1588340/img/kiel_coastline_office.png)] bg-cover bg-center bg-no-repeat" />
        {}
        <div className="absolute inset-0 bg-white/40 backdrop-blur-[2px]" />
      </div>

      {}
      <div className="relative z-10 container mx-auto px-4 text-center">
        <div ref={textRef} className={`flex flex-col items-center gap-6 transition-all duration-1000 ease-out ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {}
          <h1 className="max-w-4xl text-4xl font-bold tracking-tight text-[hsl(215,60%,15%)] sm:text-5xl md:text-6xl lg:text-[64px] lg:leading-tight">Quality Painting on the Central Coast – 30+ Years Experience</h1>

          {}
          <p className="max-w-2xl text-lg font-medium text-[hsl(200,50%,70%)] sm:text-xl md:text-2xl">
            From residential dream homes to industrial scale projects. Delivering professional coastal finishes across Gorokan, Toukley, and surrounding suburbs.
          </p>
        </div>

        {}
        <div ref={buttonsRef} className={`mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row transition-all duration-1000 delay-300 ease-out ${buttonsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {}
          <Button asChild size="lg" className="bg-[hsl(215,60%,15%)] text-white hover:bg-[hsl(42,95%,55%)] hover:text-[hsl(215,60%,15%)] border-none shadow-lg min-w-[240px] h-14 text-lg font-semibold tracking-wide transition-all">
            <Link to="/ContactPage">
              <FileText className="mr-2 h-5 w-5" />
              Get a Free Estimate
            </Link>
          </Button>

          {}
          <Button asChild variant="ghost" size="lg" className="border-2 border-[hsl(215,60%,15%)] text-[hsl(215,60%,15%)] hover:bg-[hsl(215,60%,15%)] hover:text-white min-w-[240px] h-14 text-lg font-semibold tracking-wide transition-colors">
            <Link to="/ContactPage">
              <Phone className="mr-2 h-5 w-5" />
              Call 0413 771 815
            </Link>
          </Button>
        </div>
      </div>

      {}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="flex h-12 w-12 items-center justify-center rounded-full border border-[hsl(215,60%,15%)]/20 bg-white/50 backdrop-blur-sm shadow-sm">
          <ArrowDown className="h-6 w-6 text-[hsl(215,60%,15%)]" />
        </div>
      </div>
    </section>;
}